import React from "react";
import "./button.css";

interface SimpleButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  form?: string;
  background?: string;
  className?: string;
  width?: string;
  padding?: string;
  style?: React.CSSProperties;
  isDisabled?: boolean;
}
const SimpleButton: React.FC<SimpleButtonProps> = ({
  label, onClick,
  type = "button",
  form,
  background,
  padding,
  className = "",
  style = {},
  isDisabled = false,
  width = "auto",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      form={form}
      className={`btn-simple-primary ${className}`}
      style={{
        background,
        padding,
        width,
        ...style,
      }}
      disabled={isDisabled}
    >
      {label}
    </button>
  );
};

export default SimpleButton;